'use client';
import ROUTES from '@lib/constants/routes';
import { activeTabSelector, setActiveTab } from '@lib/store/slices/TermsSlice';
import { useViewport } from '@lib/tools/hooks/useViewport';
import classNames from 'classnames';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import style from './TermsNavigation.module.scss';

export default function TermsNavigation({ navList }) {
  const [route, setRoute] = useState('mortgage');

  const refs = useRef([]);
  const tabsContainerRef = useRef(null);

  const purchaseTermsPageName = ROUTES.purchaseTerms.root.replace(/[/*]/g, '');

  const path = usePathname().replace(`/${purchaseTermsPageName}/`, '');
  const dispatch = useDispatch();
  const { isMobile } = useViewport();
  const active = useSelector(activeTabSelector);

  const onChangeLink = (cutPath, i) => {
    setRoute(cutPath);
    dispatch(setActiveTab(i));
  };

  useEffect(() => {
    setRoute(path);
  }, [path]);

  useEffect(() => {
    if (isMobile && tabsContainerRef.current) {
      const activeTabElement = tabsContainerRef?.current?.children[active];
      activeTabElement?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }, [active, isMobile]);

  return (
    <div className={style.navigation} ref={tabsContainerRef}>
      {navList?.menuItems?.map(({ path, value, hide }, i) => {
        const pattern = new RegExp(`.*${purchaseTermsPageName}/`, 'g');
        const cutPath = path.replace(pattern, '').replace('/', '');

        // скрыл таб с кэшбэком
        if (cutPath === 'cashback') return null;

        if (hide) return null;
        return (
          <Link
            key={cutPath}
            href={`${ROUTES.purchaseTerms.plainRoot}${cutPath}`}
            ref={element => {
              refs.current[i] = element;
            }}
            className={classNames(style.navigation__button, { [style.navigation__button__active]: route === cutPath })}
            onClick={() => onChangeLink(cutPath, i)}
          >
            {value}
          </Link>
        );
      })}
    </div>
  );
}
